<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame ch" id="_idContainer009">
<p class="CH-TITLE" id="_idParaDest-4"><span class="CharOverride-12"><a id="_idTextAnchor003"></a>A</span><span class="CharOverride-13">T</span>T<span class="CharOverride-14">I</span><span class="CharOverride-15">T</span><span class="CharOverride-14">U</span><span class="CharOverride-16">D</span><span class="CharOverride-13">E</span><span class="CharOverride-16"> </span><span class="CharOverride-16"> </span><br/><span class="CharOverride-16">I</span><span class="CharOverride-14">S</span><span class="CharOverride-16"> </span> <br/> <span class="CharOverride-14">E</span><span class="CharOverride-16">V</span><span class="CharOverride-14">E</span><span class="CharOverride-16">RY</span><span class="CharOverride-12">T</span><span class="CharOverride-16">HI</span><span class="CharOverride-16">N</span><span class="CharOverride-16">G</span></p>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-2">
</div>
</div>
<p class="Normal ParaOverride-5"><span class="CharOverride-17">It’s all in how you look at the world,  your life, your future.</span></p>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer010">
<p class="Normal ParaOverride-6 p2"><span class="CharOverride-18">Never say “no”  to adventures. </span></p>
<p class="Normal ParaOverride-6"><span class="CharOverride-18">Always say “yes;”  </span><span class="CharOverride-18">otherwise, you’ll lead  a very dull life.</span></p>
<p class="RED">Ian Fleming</p>
</div>
<div class="pb _idGenObjectStyleOverride-1 green" id="_idContainer012">
<p class="Normal ParaOverride-6"><span class="CharOverride-19">Get busy living  or get busy dying.</span></p>
<p class="BLUE">Stephen King</p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer013">
<img alt="" class="_idGenObjectAttribute-1" src="image/p4.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer014">
<p class="Normal ParaOverride-6 p1"><span class="CharOverride-20">I</span><span class="CharOverride-21"> want to be around a really long time.  I want to be a thorn in the side  of everything  as long as possible.</span></p>
<p class="RED">Patti Smith </p>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer015">
<p class="Normal ParaOverride-6 p3"><span class="CharOverride-22">Don’t wait.  The time will never be  just right.</span></p>
<p class="RED">Napoleon Hill</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer016">
<p class="Normal ParaOverride-6 p3"><span class="CharOverride-23">It isn’t where  you come from, it’s where you’re going   that counts.</span></p>
<p class="BLUE">Ella Fitzgerald</p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer017">
<img alt="" class="_idGenObjectAttribute-1" src="image/p8.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer018">
<p class="cond-heavy-lowercase p1"><span class="CharOverride-24">I don’t have  any rules, because  I’d only be breaking them.</span></p>
<p class="BLUE">Iris Apfel</p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer019">
<img alt="" class="_idGenObjectAttribute-1" src="image/4.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer020">
<p class="amatic-reg p2"><span class="CharOverride-25">I wake up every day  and I think,  “I’m breathing!  It’s a good day.”</span></p>
<p class="RED">Eve Ensler</p>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer021">
<p class="amatic-bold p2"><span class="CharOverride-26">What I  love best  in life is  new starts.</span></p>
<p class="RED">Karl Lagerfeld</p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer022">
<img alt="" class="_idGenObjectAttribute-1" src="image/p13.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer023">
<p class="Normal p2 ParaOverride-6"><span class="CharOverride-27">I’m thrilled  to death  with life.</span></p>
<p class="BLUE">Johnny Cash</p>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer024">
<p class="Normal ParaOverride-6 p1"><span class="CharOverride-20">I</span><span class="CharOverride-21"> prefer to be  a beautiful woman of my age than try desperately to  look 30.</span></p>
<p class="RED">Demi Moore</p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer025">
<img alt="" class="_idGenObjectAttribute-1" src="image/5.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer026">
<p class="Normal ParaOverride-6 p1"><span class="CharOverride-22">At the end of every movie, always I’m feeling,  “You’re never going  to work again.”  That’s going to happen  one day, but I hope  I’m not alive. </span></p>
<p class="RED">Lauren Bacall</p>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer027">
<p class="Normal ParaOverride-6"><span class="CharOverride-20">N</span><span class="CharOverride-28">obody looks good when they get ol</span><span class="CharOverride-28">d . . .  </span><span class="CharOverride-28">but what the hell can you do about it? Nothing. So you may as well ignore it as best you can and just be  who you are.</span></p>
<p class="RED">Grace Slick </p>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer028">
<p class="amatic-bold p3"><span class="CharOverride-29">I need to retire  from retirement.</span></p>
<p class="BLUE">Sandra Day O’Connor</p>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer029">
<p class="Normal ParaOverride-6 p1"><span class="CharOverride-30">It’s the rudest word in my  dictionary, “retire.” And “old”  is another one. I don’t allow that in my house. And being called “vintage.” I don’t want any of these old words.  I like “enthusiastic.”</span></p>
<p class="RED">Judi Dench</p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer030">
<img alt="" class="_idGenObjectAttribute-1" src="image/6.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer031">
<p class="Normal ParaOverride-6 p2"><span class="CharOverride-31">Getting old is a fascinating thing.  The older you get, the older you  want to get.</span></p>
<p class="BLUE">Keith Richards</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SoWhosCounting_epub_final3.vue?3d99b744